import AUTH_TYPES from "../types/authTypes";

const initialState = {
  isAuthenticated: false,
  token: null,
  profile: {},
  bankAvailable: false,
  w9formFilled:false

};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case AUTH_TYPES.RESET_STATE:
      return initialState;

    case AUTH_TYPES.LOGIN_SUCCESS:
      return {
        ...state,
        submitting: false,
        isAuthenticated: true,
        token: action.payload.token,
        profile: action.payload.profile,
        bankAvailable: action.payload.bank_available,
        w9formFilled:action.payload.w9form_filled
      };

    case AUTH_TYPES.LOGOUT:
      return {
        ...state,
        submitting: false,
        isAuthenticated: false,
        bankAvailable: false,
        w9formFilled:false,
        profile: {},
        token: null,
        role: null,
      };

    case AUTH_TYPES.UPDATE_PROFILE:
      return {
        ...state,
        profile: action.payload,
      };
    case AUTH_TYPES.ACCOUNT_CREATED:
      return {
        ...state,
        bankAvailable: true,
      };
      case AUTH_TYPES.W9_FILLED:
       return {
          ...state,
          w9formFilled: true,
        };

    default:
      return state;
  }
}
